import styled from 'styled-components';

import { TRANSITION_DURATION_MS } from './constants';
import { navigationDefaultColors } from './data';

export const StyledNavigationContainer = styled.nav`
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  will-change: contents;
  background-color: ${navigationDefaultColors.navContainerBgColor};
  transition: all ${TRANSITION_DURATION_MS}ms ease;
  border-right: 1px solid ${navigationDefaultColors.navContainerBorderColor};

  &.expanded-state {
    width: 240px;
  }

  &.collapsed-state {
    width: 72px;
  }
`;
